export default "__VITE_ASSET__943e1420__"